//# sourceMappingURL=/s/files/1/0632/4515/6571/t/38/assets/custom.js.map?v=1680491532

if($(window).width()<=768){
  setTimeout(function(){
    $(".template-product video").each(function(){
  var video = $(this)[0],src=$(this).find('source').attr("src");
  video.load();
      video.muted = true;
  video.onloadedmetadata = function() {
    video.play();
  };

 
  blob_load = (src) => {
    const req = new XMLHttpRequest();
    req.open("GET", src, true);
    req.responseType = "blob";
    req.onload = function () {
      // Onload is triggered even on 404
      // so we need to check the status code
      if (this.status === 200) {
        const videoBlob = this.response;
        const blobSrc = URL.createObjectURL(videoBlob); // IE10+
        // Video is now downloaded
        // and we can set it as source on the video element
        // video.src = blobSrc ;
        
        console.log(blobSrc, "blobSrc加载完毕");
      }
    };
    req.onerror = function () {
      // Error
    };
    req.send();
  };

      
});
    
  },2000)

  
}
